import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import type { SubmitHandler } from 'react-hook-form';

import appLogo from '../../ui/assets/images/app-icon.svg';
import { StyledResetPasswordPage } from './ResetPasswordPage.style';
import { useAppDispatch, useAppSelector } from '../../store/store';
import mainSliceThunks from '../../store/mainSlice/mainSlice.thunks';
import { routerConstants } from '../../routes/constants';
import { showErrorMessage } from '../../utils/handleErrors';

type ResetPasswordInputsType = {
  email: string;
};

const ResetPasswordPage: React.FC = () => {
  const isAuth = useAppSelector(({ userState }) => userState.isAuthChecked);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { register, handleSubmit, reset } = useForm<ResetPasswordInputsType>();

  React.useEffect(() => {
    if (isAuth) {
      navigate(routerConstants.home, { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit: SubmitHandler<ResetPasswordInputsType> = async (data) => {
    try {
      await dispatch(mainSliceThunks.resetPassword(data)).unwrap();
    } catch (error: unknown) {
      showErrorMessage(error);
    }
    reset();
    navigate(routerConstants.home, { replace: true });
  };
  const signIn = () => {
    return () => {
      navigate(routerConstants.signIn, { replace: true });
    };
  };

  return (
    <StyledResetPasswordPage>
      <img src={appLogo} alt="Logo" className="reset-password__logo" />
      <div className="reset-password__title">application</div>
      <div className="reset-password__text">Reset your account password</div>
      <form onSubmit={handleSubmit(onSubmit)} className="reset-password-form">
        <label className="reset-password-form__label">Email address</label>
        <input
          {...register('email')}
          className="reset-password-form__input"
          placeholder="Enter your email address..."
        />
        <div className="reset-password-form__sign-in" onClick={signIn()}>Sign In</div>
        <button type="submit" className="reset-password-form__button">
          Send
        </button>
      </form>
    </StyledResetPasswordPage>
  );
};

export default ResetPasswordPage;
